import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  footer: {
    backgroundColor: "#fafafa",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    height: "20px",
    marginTop: "-20px",
    zIndex: "100",
    position: "relative"
  }
});

const year = new Date().getFullYear();

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.footer}>
      Copyright © {year} The Dallas Morning News. All rights reserved.
      {process.env.REACT_APP_GIT_SHA
        ? ` | Version: ${process.env.REACT_APP_GIT_SHA}`
        : ""}
      {process.env.REACT_APP_GIT_BRANCH
        ? ` | Branch: ${process.env.REACT_APP_GIT_BRANCH}`
        : ""}
    </div>
  );
};

export default Footer;
